import "./ListaUsuarios.css";

const ListaUsuarios = ({ lista = [], onEdit }) => {
  const itens = lista;

  const renderizarStatus = (status) => {
    switch (status) {
      case "ACTIVE":
        return <span className="status-pill status-ativo">Ativo</span>;
      case "INACTIVE":
        return <span className="status-pill status-inativo">Inativo</span>;
      default:
        return <span className="status-pill">-</span>;
    }
  };

  const formatarDataBR = (data) => {
    if (!data) return "-";
    return new Intl.DateTimeFormat("pt-BR").format(new Date(data));
  };

  return (
    <section className="table-card">
      <div className="title-list">
        Admin pode <strong>cadastrar e editar licenciados</strong>, além de acessar{" "}
        <strong>extrato</strong> e <strong>dados bancários</strong> de cada usuário.
      </div>

      <div className="tablela">
        <table>
          <thead>
            <tr>
              <th>Nome do licenciado</th>
              <th>E-mail de acesso</th>
              <th>Status</th>
              <th>Data de criação</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody id="usuariosTableBody">
            {itens.map((item) => (
              <tr key={item.id}>
                <td>{item.nome}</td>
                <td>{item.email}</td>
                <td>{renderizarStatus(item.status)}</td>
                <td>{formatarDataBR(item.dataCriacao)}</td>
                <td>
                  <div className="actions-cell">
                    <button
                      className="action-btn"
                      data-id={item.id}
                      data-action="editar"
                      onClick={() => onEdit?.(item.id)}
                    >
                      ✏️ <span>Editar</span>
                    </button>

                    <button className="action-btn" data-id={item.id} data-action="extrato">
                      📄 <span>Ver extrato</span>
                    </button>

                    <button className="action-btn" data-id={item.id} data-action="bancarios">
                      🏦 <span>Dados bancários</span>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <div id="usuariosInfo">{itens.length} licenciados encontrados</div>
      </div>
    </section>
  );
};

export default ListaUsuarios;
